import { groq } from '#imports';

export function getQuery() {
  return groq`count(*[_type == "article" && !(_id in path('drafts.**'))] {
    slug,
  })`;
}
